import object from '@mailobj-browser/front/js/utils/object.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import input from '@mailobj-browser/front/js/events/types/input.js'
import meta from '#utilities/js/ea/meta.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'

const onInput = object(listener, {
  type: input,
  passive,
  task: async (
    input
  ) => {
    const { name, value, ownerDocument } = input
    const meta = one(`meta[name="ea_${name}"]`, ownerDocument)
    if (meta) {
      meta.content = value
    } else {
      const newMeta = document.createElement('meta')
      newMeta.name = 'ea_' + name
      newMeta.content = value
      document.getElementsByTagName('head')[0].appendChild(newMeta)
    }
  }
})

export default input => {
  onInput.listen(input)
}